/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Home.css';


class Home extends React.Component {
  static propTypes = {
    news: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired,
      content: PropTypes.string,
    })).isRequired,
    getDefaultProps:PropTypes.func,


  };


  render() {
    return (
      <div className={s.root}>
        <canvas ref="canvas" width={100} height={100}></canvas>
        <div className={s.content}>

          <div className={s.tit}>
            <h2 className={s.h2Tit}>数字品牌榜</h2>
            <span className={s.h2EnTit}>WELCOME TO DBRANK</span>
            <div className={s.tryBtn}>
                立即试用
              </div>
          </div>
        </div>

      </div>
    );
  }
  // render() {
  //   return (
  //     <div className={s.root}>
  //       <div className={s.container}>
  //         <h1>React.js News</h1>
  //         {this.props.news.map(item => (
  //           <article key={item.link} className={s.newsItem}>
  //             <h1 className={s.newsTitle}><a href={item.link}>{item.title}</a></h1>
  //             <div
  //               className={s.newsDesc}
  //               // eslint-disable-next-line react/no-danger
  //               dangerouslySetInnerHTML={{ __html: item.content }}
  //             />
  //           </article>
  //         ))}
  //       </div>
  //     </div>
  //   );
  // }
}

export default withStyles(s)(Home);



// WEBPACK FOOTER //
// src/routes/homeform/Home.js